"use strict";
exports.__esModule = true;
exports.EMBED_CHANGE_CARD_BILLING_ADDRESS_DETAILS = exports.EMBED_CHANGE_CARD_ERROR_HANDLING = exports.EMBED_CHANGE_CARD = void 0;
exports.EMBED_CHANGE_CARD = {
    BACK: 'Back',
    BODY: 'To access your line of credit, link the card you’d like to use for your payments to Flex (including the monthly membership fee).',
    CTA: 'Confirm card',
    HEADER: 'Update card details',
    NOTICE: 'Credit cards subject to processing fee'
};
exports.EMBED_CHANGE_CARD_ERROR_HANDLING = {
    BILLING_INCLUDE_NAME: 'Please include a name with your billing information',
    BILLING_REQUIRED: 'Billing information is a required field',
    CARD_REQUIRED: 'Card number is a required field'
};
exports.EMBED_CHANGE_CARD_BILLING_ADDRESS_DETAILS = {
    CTA_CHANGE_BILLING_ADDRESS: 'Change',
    CTA_CONFIRM_CARD: 'Confirm card',
    DISCLAIMER: 'Your data is secured by bank-level encryption',
    HEADER: 'Billing information'
};
